export default "__VITE_ASSET__b4BXg6yn__"